import { useCallback } from 'react';
import { useCallInsightController } from '@frontend/call-insight-panel';
import { useChannelSubscription } from '@frontend/queue';

export const useCallInsightsChannelSubscription = () => {
  const { open: openCallInsightPanel } = useCallInsightController({
    source: 'callHistory',
  });

  useChannelSubscription(
    'call-insights',
    useCallback(
      (data) => {
        const { channelId, locationId } = data.payload;

        try {
          openCallInsightPanel({
            channelId,
            locationId,
            includeCallIntelligence: true,
          });
          console.log('OPENING CALL INSIGHT PANEL');

          return true;
        } catch (error) {
          console.error('Failed to open Call Insight Panel:', error);
          return false;
        }
      },
      [openCallInsightPanel]
    )
  );
};
